// extracted by mini-css-extract-plugin
export default {"form":"Checkout_form__S0xbZ","control":"Checkout_control__kWrKW","actions":"Checkout_actions__gy1kL","submit":"Checkout_submit__QilJI","invalid":"Checkout_invalid__OqsN5"};